import { ActivityFeed } from 'src/graphql/entities/activity-feed/hooks/use-activity-feed';
import { ActivityFeedTime } from './acitivity-feed-time';
import { ChatActivityContainer } from './chat-activity-container';
import { StyledTypography } from './styled/typography.styled';

export const CreateConversationActivityMessage = ({
  activity,
}: {
  activity: ActivityFeed;
}) => {
  return (
    <ChatActivityContainer
      icon="flare"
      title={
        <StyledTypography>
          <b>{activity.actor.name}</b> created conversation{' '}
          <ActivityFeedTime activity={activity} />
        </StyledTypography>
      }
    />
  );
};
